import React from "react";
import dynamic from "next/dynamic";
import { string } from "prop-types";

import { useTranslation } from "@lib/i18n";

import { useLeadTimePopinSelector } from "@redux/reducers/appConfig";

import InfoIcon from "@components/shared/Icons/InfoIcon";

const ReactTooltip = dynamic(() => import("react-tooltip"), {
  ssr: false,
});

const LeadTimeTooltip = ({ id }) => {
  const { t } = useTranslation();
  const showTooltip = useLeadTimePopinSelector();

  return (
    showTooltip && (
      <div className="inline-flex items-center whitespace-nowrap">
        <div className="ml-2 text-greyLight" data-tip data-for={id}>
          <InfoIcon className="size-4 before:text-black after:text-black" />
        </div>

        <ReactTooltip id={id} effect="solid" place="right">
          <div style={{ whiteSpace: "normal", maxWidth: 220 }}>
            {t("basket.orderSummary.leadDateDetails")}
          </div>
        </ReactTooltip>
      </div>
    )
  );
};

LeadTimeTooltip.propTypes = {
  id: string.isRequired,
};

export default LeadTimeTooltip;
